// special casing the layout nodes by reaching in from the core. not generally recommended but with only a small handful
// it is fine for now
export const LayoutNodeSpecs = Object.freeze({
  "layout.slot": { nodeReferenceProperty: "contentId", titleProperty: "title", optional: false },
  "flexbox.container": { nodeReferenceProperty: "contentId", titleProperty: "title", optional: true },
}) satisfies Readonly<Record<string, { nodeReferenceProperty: string; titleProperty: string; optional: boolean }>>;

export type LayoutNodeSpecs = typeof LayoutNodeSpecs;
